import Firebase from 'firebase';

// Initialize Firebase
const config = {
  apiKey: "AIzaSyBiP2ouIzedfgirbXKLR5-F1n3-gfwbL-8",
  authDomain: "naturepower-4a80e.firebaseapp.com",
  databaseURL: "https://naturepower-4a80e.firebaseio.com",
  projectId: "naturepower-4a80e",
  storageBucket: "naturepower-4a80e.appspot.com",
  messagingSenderId: "313762545701"
};

const firebaseApp = Firebase.initializeApp(config);

export default firebaseApp;